'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { Link } from '@/components/ui/link';
import { FOOTER_GROUPS } from '@/constants/navigation';
import { GithubStarButton } from './github-star-button';
import { LocaleSwitcher } from './locale-switcher';
import { NowPlaying } from './now-playing';
export function LayoutFooter() {
  const $ = _c(9);
  const t = useTranslations();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <NowPlaying className="mb-12" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t) {
    t1 = FOOTER_GROUPS.map(group => <div key={group.id} className="flex flex-col items-start gap-4">{group.links.map(link => <Link key={link.href} href={link.href} className="text-muted-foreground transition-colors hover:text-foreground">{t(link.labelKey)}</Link>)}</div>);
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <div className="mb-30 grid grid-cols-2 gap-10 sm:grid-cols-3">{t1}</div>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <LocaleSwitcher />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="mt-20 space-y-4">{t3}<div className="flex items-center justify-between text-sm"><div className="text-muted-foreground">© {new Date().getFullYear()} Nelson Lai</div><GithubStarButton /></div></div>;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t2) {
    t5 = <footer className="mx-auto mb-12 w-full max-w-5xl rounded-2xl bg-background/30 p-8 backdrop-blur-md">{t0}{t2}{t4}</footer>;
    $[7] = t2;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}